import Image from 'next/image'
import {
    FaTwitter,
    FaDiscord,
    FaHome
} from 'react-icons/fa'
import {
    SiRoblox
} from 'react-icons/si'
import { useRouter } from 'next/router'
import NoctovoLogo from "@/public/noctovo.svg"
import { useEffect, useState } from 'react'

const footerNav = [
    {
        name: 'Home',
        href: '/',
        icon: FaHome
    },
    {
        name: "Discord",
        href: "https://discord.gg/combatwarriors",
        icon: FaDiscord
    },
    {
        name: "Twitter",
        href: "https://twitter.com/CWRBLX",
        icon: FaTwitter
    },
    {
        name: "Roblox",
        href: "https://www.roblox.com/games/4282985734/Combat-Warriors",
        icon: SiRoblox
    }
]

export default function Footer({ buildId }) {
    const router = useRouter();

    const noRenderOn = [/^\/staff/, /^\/staff.*/, /^\/ip-ban/];

    useEffect(() => {
        if (noRenderOn.some((pattern) => pattern.test(router.pathname))) {
            setShouldRender(false);
        } else {
            setShouldRender(true);
        }
    }, [router.pathname]);

    const [shouldRender, setShouldRender] = useState(true);

    if (!shouldRender) return null;

    return (   
        <footer className="rounded-lg shadow bg-black">
            <div className="w-full max-w-screen-xl mx-auto p-8 md:py-8">
                <div className="sm:flex sm:items-center sm:justify-between">
                    <a className="flex items-center cursor-pointer transition hover:scale-95">
                        <Image
                            src="/cw_logo.svg"
                            alt="CW Logo"
                            width={100}
                            height={100}
                            onClick={() => router.push('/')}
                            className="-mb-2"
                        />
                    </a>
                    <ul className="flex flex-wrap items-center mb-6 text-sm font-medium text-gray-500 sm:-mb-12 dark:text-gray-400">
                        {footerNav.map((item) => (
                            <button className="px-4 py-2 text-white transition-colors duration-200 transform rounded-md hover:bg-white hover:bg-opacity-20" onClick={() => router.push(item.href)}>
                                {item.icon && (
                                    <item.icon className="w-5 h-5" aria-hidden="true" />
                                )}
                                {item.name && !item.icon && (
                                    item.name
                                )}
                            </button>
                        ))}
                    </ul>
                </div>
                <hr className="my-6 border-white/25 sm:mx-auto" />
                <span className="block text-sm text-white sm:text-center">
                    © {new Date().getFullYear()} Combat Warriors | Build {buildId}
                </span>
                <span className="block text-sm text-white sm:text-center mt-2">
                    <span
                        className="text-white hover:underline cursor-pointer"
                        onClick={() => router.push("/legal/terms")}
                    >
                        Terms of Service
                    </span>
                    {" | "}
                    <span
                        className="text-white hover:underline cursor-pointer"
                        onClick={() => router.push("/legal/privacy")}
                    >
                        Privacy Policy
                    </span>
                </span>
                <span className="flex justify-center items-center text-white mt-1 hover:underline cursor-pointer" onClick={() => window.open("https://noctovo.com/")}>
                    A{""}
                    <Image
                        src={NoctovoLogo}
                        alt="Noctovo Logo"
                        width={30}
                        height={30}
                        className="mx-2"
                    />
                    Project
                </span>
            </div>
        </footer>
    )
}